// LANGUE & DEVICE -------------------------------------
// LANGUE -----------------------------
$("#tool-language p span").eq(1).click(()=>{ // ENGLISH -----------------------------
    french_to_english();
})
$("#tool-language p span").eq(0).click(()=>{ // FRENCH ---------------------------
    english_to_french();
})
// DEVISE -------------------------------------
$("#tool-devise p span").eq(1).click(()=>{ // DOLLARS
    device_symbole="$";
    chg_device=USD;
    if(language=="FR"){
        english_to_french()
    }
    else{
        french_to_english()
    }
})
$("#tool-devise p span").eq(0).click(()=>{ // EUROS
    device_symbole="€";
    chg_device=1.00;
    if(language=="FR"){
        english_to_french()
    }
    else{
        french_to_english()
    }
})

// traduction.js
var device_symbole="€";
var chg_device="1";
var language="FR";
// LANGUAGE ENGLISH ---------------------------
function french_to_english(){
    language="EN"
    $("#tool-panel-full-screen").attr('title',"Full Screen");
    $("#tool-reset").attr('title',"Reset");
    $("#tool-shape__1").attr('title',"Square");
    $("#tool-shape__2").attr('title',"Rectangle");
    $("#tool-shape__3").attr('title',"Circle");
    $("#square-width input").eq(0).attr('title',"Width/Height");
    $("#rectangle-width input").eq(0).attr('title',"Width");
    $("#rectangle-width input").eq(1).attr('title',"Height");
    $("#circle-diam input").eq(0).attr('title',"Diameter");
    $("#tool-language p span").eq(0).attr('title',"French");
    $("#tool-language p span").eq(1).attr('title',"English");
    $("#tool-buy").html("Buy");
 	$("#page1-next").html("Buy");
  	$("#page2 h1").html("Step 2: Choose your texture");
  	$("#page2 #page2-option1 p").html("Smooth panel (+0€)");
  	$("#page2 #page2-option1 button").html("Choose This Option");
  	$("#page2 #page2-option2 p").html("Diamond pattern engraving (+40€)");
  	$("#page2 #page2-option2 button").html("Choose This Option");
 	$("#page3 h1").html("Step 3: Choose your edges");
  	$("#page3 #page3-option1 p").html("Full edges (+0€)");
  	$("#page3 #page3-option1 button").html("Choose This Option");
  	$("#page3 #page3-option2 p").html("Beveled edges (+7€)");
  	$("#page3 #page3-option2 button").html("Choose This Option");
    $("#page3-retour span").html("Return");
  	$("#page2-retour span").html("Return");
  	$("#page4-retour span").html("Return");
  	$("#page4 h1").html("Step 4: Would you like to add an additional pegboard?");
  	$("#page4-rep button").eq(0).html("Yes, go back to the configurator");
  	$("#page4-rep button").eq(1).html("No, go to cart");
    $("#selection-retour span").html("Return");
    // accessoires 
  	for(i=1;i<=articles.length;i++){
    	$("#tool-panel-accesoires-selection div").eq(i-1).children().html(""+articles[i-1].nom_EN+" (<span>"+Math.round($("#tool-panel-accesoires-selection div").eq(i-1).children().eq(2).attr('class')*chg_device*10)/10+""+device_symbole+"</span>)")
    }
  // dossiers
  for(i=1;i<=dossiers.length;i++){
    	$("#tool-panel-accesoires-selection nav").eq(i-1).children().eq(0).html(""+dossiers[i-1].nom_EN+"")
    }
}
// LANGUAGE FRENCH ---------------------------
function english_to_french(){
    language="FR"
    $("#tool-panel-full-screen").attr('title',"Plein Ecran");
    $("#tool-reset").attr('title',"Réinitialiser");
    $("#tool-shape__1").attr('title',"Carre");
    $("#tool-shape__2").attr('title',"Rectangle");
    $("#tool-shape__3").attr('title',"Cercle");
    $("#square-width input").eq(0).attr('title',"Largeur/Hauteur");
    $("#rectangle-width input").eq(0).attr('title',"Largeur");
    $("#rectangle-width input").eq(1).attr('title',"Hauteur");
    $("#circle-diam input").eq(0).attr('title',"Diametre");
    $("#tool-language p span").eq(0).attr('title',"Français");
    $("#tool-language p span").eq(1).attr('title',"Anglais");
    $("#tool-buy").html("Acheter");
 	$("#page1-next").html("Acheter");
  	$("#page2 h1").html("Étape 2 : Choisissez votre texture");
  	$("#page2 #page2-option1 p").html("Panneau lisse (+0€)");
  	$("#page2 #page2-option1 button").html("Choisir Cette Option");
  	$("#page2 #page2-option2 p").html("Gravure à motif losanges (+40€)");
  	$("#page2 #page2-option2 button").html("Choisir Cette Option");
 	$("#page3 h1").html("Étape 3 : Choisissez vos arêtes");
  	$("#page3 #page3-option1 p").html("Arêtes entières (+0€)");
  	$("#page3 #page3-option1 button").html("Choisir Cette Option");
  	$("#page3 #page3-option2 p").html("Arêtes biseautées (+7€)");
  	$("#page3 #page3-option2 button").html("Choisir Cette Option");
    $("#page3-retour span").html("Retour");
  	$("#page2-retour span").html("Retour");
  	$("#page4-retour span").html("Retour");
  	$("#page4 h1").html("Étape 4 : Souhaitez vous ajouter un pegboard supplémentaire ?");
  	$("#page4-rep button").eq(0).html("Oui, retourner au configurateur");
  	$("#page4-rep button").eq(1).html("Non, aller au panier");
  	$("#selection-retour span").html("Retour");
    // accessoires 
    for(i=1;i<=articles.length;i++){
    	$("#tool-panel-accesoires-selection div").eq(i-1).children().html(""+articles[i-1].nom_FR+" (<span>"+Math.round($("#tool-panel-accesoires-selection div").eq(i-1).children().eq(2).attr('class')*chg_device*10)/10+""+device_symbole+"</span>)")
    }
  // dossiers
  for(i=1;i<=dossiers.length;i++){
    	$("#tool-panel-accesoires-selection nav").eq(i-1).children().eq(0).html(""+dossiers[i-1].nom_FR+"")
    }

}